import { hideAll } from "tippy.js";
import { v4 } from "uuid";

// Supposedly faster than object.keys or other methods
export function isEmptyObject(obj) {
  for (let i in obj) return false;
  return true;
}

export const waiter = (time) => new Promise((res) => setTimeout(res, time));

export function hideAllPoppersInstantly() {
  window.efs_debug && window.log("trying to hide all poppers");
  hideAll({ duration: 0 });
}

export const beforeUnloadInterceptor = (e) => {
  if (process.env.NODE_ENV === "production") {
    e.preventDefault();
    e.stopImmediatePropagation();
    return (e.returnValue = "Are you sure you want to exit?");
  }
};

let colours = [
  "#797979",
  "#3c7070",
  "#3c5670",
  "#4b3c70",
  "#6f3c70",
  "#703c5b",
  "#703c3c",
  "#3c706b",
  "#3c7047",
  "#50703c",
  "#706e3c",
  "#705b3c",
];
export const getAvatarBackColor = (given_name) =>
  given_name ? colours[given_name.charCodeAt(0) % 12] : colours[0];

export function getPersonInitials(given_name, family_name) {
  if (!given_name || !family_name) {
    return "?";
  }
  return `${given_name[0] ? given_name[0] : ""}${
    family_name[0] ? (family_name === "(guest)" ? "" : family_name[0]) : ""
  }`;
}

export const getPersonName = (given_name, family_name) =>
  !given_name || !family_name ? "Deleted User" : `${given_name} ${family_name}`;

export const makeGUID = () => v4();
